export function getProductionDesignCode(sku, overrides = {}) {
  const normalizedSku = String(sku || '').trim().toUpperCase();
  const override = overrides[normalizedSku];
  if (override) return override;
  const parts = normalizedSku.split('-');
  return parts.length >= 2 ? parts[parts.length - 2].trim() : '';
}

export async function loadProductionDesignFiles(skus, currentUser) {
  const unique = [...new Set(skus.map(sku => String(sku || '').trim().toUpperCase()).filter(Boolean))];
  if (!unique.length) return {};
  const token = await currentUser.getIdToken();
  const response = await fetch('/api/v1/production-design-files/resolve', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ skus: unique }),
  });
  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || 'Could not load master design file numbers.');
  return data.overrides || {};
}
